import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";

const STEPS = [
  { n: "01", t: "Kostenloses Erstgespräch", d: "Wir hören zu, verstehen Ihr Geschäft und prüfen, wo der grösste Hebel liegt. Unverbindlich, 30 Minuten." },
  { n: "02", t: "Festpreisangebot innerhalb 48 Stunden", d: "Klare Leistungen, klarer Preis, klarer Zeitplan — auf einer Seite. Keine Überraschungen." },
  { n: "03", t: "Design, Entwicklung, Content", d: "Konzept, Wireframes, Design, Code, Fotos, Texte. Wöchentliche Zwischenstände statt monatelanger Blackbox." },
  { n: "04", t: "Launch & Übergabe", d: "Wir gehen live und übergeben eine sauber dokumentierte Website — nichts ist Blackbox." },
  { n: "05", t: "Laufende Betreuung & Performance Marketing", d: "Wartung, Reporting, Meta Ads, Optimierung. Ein System, das dauerhaft Anfragen liefert." },
];

function Step({ s, i, total }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15% 0px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 36 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
      className="relative grid grid-cols-12 gap-6 pb-12 md:pb-16"
      data-testid={`step-${i}`}
    >
      <div className="col-span-12 md:col-span-2 flex md:flex-col items-center md:items-start gap-3 relative">
        <div className="relative z-10 w-11 h-11 rounded-full bg-[#0A0A0A] text-[#C9A961] flex items-center justify-center font-mono-eyebrow">
          {s.n}
        </div>
        <span className="font-mono-eyebrow text-[#0A0A0A]/50 md:mt-3">Schritt {i + 1} / {total}</span>
      </div>
      <div className="col-span-12 md:col-span-10 md:pl-8 border-l md:border-l-0 md:border-t border-[#E5E5E0] pt-6 md:pt-0">
        <h3 className="font-serif-editorial text-3xl md:text-5xl leading-[1.05] tracking-tight">{s.t}</h3>
        <p className="mt-4 text-[#0A0A0A]/70 text-base md:text-lg leading-relaxed max-w-2xl">{s.d}</p>
      </div>
    </motion.div>
  );
}

export default function Ablauf() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 40%", "end 80%"] });
  const fillH = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="ablauf" ref={ref} className="bg-[#FAFAF7] py-24 md:py-36 border-t border-black/5">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 lg:col-span-4">
            <span className="chapter-num">04 — Ablauf</span>
          </div>
          <h2 className="col-span-12 lg:col-span-8 font-serif-editorial text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
            Von der Idee<br />zum <em className="italic text-[#C9A961]">System</em>.
          </h2>
        </div>

        <div className="relative">
          {/* timeline rules */}
          <div className="hidden md:block absolute top-0 bottom-0 left-[22px] w-px bg-[#E5E5E0]" />
          <motion.div
            className="hidden md:block absolute top-0 left-[22px] w-px bg-[#C9A961]"
            style={{ height: fillH }}
          />
          {STEPS.map((s, i) => <Step key={s.n} s={s} i={i} total={STEPS.length} />)}
        </div>

        <div className="mt-6 md:mt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-black/10 pt-10">
          <p className="font-serif-editorial text-2xl md:text-3xl max-w-xl">
            Bereit für Schritt eins?
          </p>
          <button
            onClick={() => document.getElementById("kontakt")?.scrollIntoView({ behavior: "smooth" })}
            className="btn-primary"
            data-testid="ablauf-cta"
          >
            Jetzt kostenloses Erstgespräch buchen <ArrowUpRight size={16} className="arrow" />
          </button>
        </div>
      </div>
    </section>
  );
}
